// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__CVM50","list":"BalanceDue_list__yxsJU","listRow":"BalanceDue_listRow__2VVHj","total":"BalanceDue_total__2wkm2"};